<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header" v-if="isIndex()">
        <template>
          <el-dialog
            :title="`${$t('common_words.plan')} OPT`"
            :visible.sync="dialogVisible"
            width="70%"
            :before-close="handleClose"
          >
            <el-form
              :label-position="'top'"
              :model="model"
              :rules="rules"
              ref="form"
            >
              <el-row :gutter="20">
                <el-col :md="8">
                  <el-form-item
                    :label="`${$t('grow.responsible')}`"
                    prop="responsibleId"
                  >
                    <el-select
                      filterable
                      v-model="model.responsibleId"
                      :placeholder="`${$t('common_words.select')}...`"
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      :disabled="isDisabled"
                    >
                      <el-option
                        v-for="(user, key) in listUsers"
                        :key="key"
                        :label="user.name"
                        :value="user.id"
                        class="select-primary"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8">
                  <el-form-item
                    :label="`${$t('grow.observed')}`"
                    prop="observedId"
                  >
                    <el-select
                      filterable
                      v-model="model.observedId"
                      :placeholder="`${$t('common_words.select')}...`"
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      :disabled="isDisabled"
                    >
                      <el-option
                        v-for="(user, key) in listObserveds"
                        :key="key"
                        :label="user.name"
                        :value="user.id"
                        class="select-primary"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8">
                  <el-form-item
                    :label="`${$t('common_words.email')}`"
                    prop="email"
                  >
                    <el-input
                      v-model="model.email"
                      placeholder="xxxx@gmail.com"
                      class="shadow-sm"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="7">
                  <el-form-item
                    :label="`${$t('common_words.date_of_record')}`"
                    prop="date"
                  >
                    <el-date-picker
                      v-model="model.date"
                      class="shadow-sm"
                      type="date"
                      value-format="yyyy-MM-dd"
                      size="large"
                      :placeholder="`${$t('common_words.select2')}...`"
                      :picker-options="pickerOptions"
                      :disabled="isDisabled"
                      :clearable="false"
                      @change="handleChangeDate"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :md="7">
                  <el-form-item
                    :label="`${$t('common_words.hour')}`"
                    prop="timeRange"
                  >
                    <el-time-picker
                      is-range
                      v-model="model.timeRange"
                      format="HH:mm"
                      value-format="HH:mm"
                      :placeholder="`${$t('common_words.select2')}...`"
                      :clearable="false"
                      :disabled="isDisabled"
                  /></el-form-item>
                </el-col>
                <el-col :md="5">
                  <el-form-item
                    :label="`${$t('common_words.year')}`"
                    prop="year"
                  >
                    <el-input
                      v-model="model.year"
                      :placeholder="`${$t('common_words.year')}`"
                      class="shadow-sm"
                      disabled
                    ></el-input> </el-form-item
                ></el-col>
                <el-col :md="5">
                  <el-form-item
                    :label="`${$t('common_words.week')}`"
                    prop="week"
                  >
                    <el-input
                      v-model="model.week"
                      :placeholder="`${$t('common_words.week')}`"
                      class="shadow-sm"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="8">
                  <el-form-item
                    :label="`${$t('common_words.farm')}`"
                    prop="farmId"
                  >
                    <el-select
                      filterable
                      v-model="model.farmId"
                      :placeholder="`${$t('common_words.select')}...`"
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      :disabled="isDisabled"
                    >
                      <el-option
                        v-for="(farm, key) in listFarms"
                        :key="key"
                        :label="farm.name"
                        :value="farm.id"
                        class="select-primary"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8">
                  <el-form-item
                    :label="`${$t('common_words.area')}`"
                    prop="areaId"
                  >
                    <el-select
                      filterable
                      v-model="model.areaId"
                      :placeholder="`${$t('common_words.select')}...`"
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      :disabled="isDisabled"
                    >
                      <el-option
                        v-for="(area, key) in listAreas"
                        :key="key"
                        :label="area.name"
                        :value="area.id"
                        class="select-primary"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8">
                  <el-form-item :label="`${$t('common_words.status')}`">
                    <el-input
                      v-model="model.status"
                      class="shadow-sm statusOptexpired"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item class="text-center">
                <el-button
                  class="btn btn-warning custom-shadow-btn"
                  @click="resetForm('form')"
                  >{{ $t('common_words.cancel') }}</el-button
                >
                <el-button
                  v-if="model.id && !isDisabled"
                  class="btn btn-danger custom-shadow-btn"
                  @click="handleEventRemove(model.id)"
                  >{{ $t('common_words.delete') }}</el-button
                >
                <el-button
                  v-if="!isDisabled"
                  class="btn btn-success custom-shadow-btn"
                  @click="handleEventAdd('form')"
                  >{{ $t('common_words.save') }}</el-button
                >
                <el-button
                  v-if="!isDisabled"
                  class="btn btn-fg btn-add custom-shadow-btn"
                  @click="formOPT('formOPT')"
                  >{{ $t('grow.perform') }}</el-button
                >
              </el-form-item>
            </el-form>
          </el-dialog>

          <el-dialog
            :title="`${$t('common_words.filters')}`"
            :visible.sync="dialogVisibleFilters"
            width="60%"
          >
            <el-form
              :label-position="'top'"
              :model="filter"
              :rules="rulesFilter"
              ref="filter"
            >
              <el-row :gutter="20">
                <el-col :md="12">
                  <el-form-item
                    :label="`${$t('grow.responsibles')}`"
                    prop="responsibleIds"
                  >
                    <el-select
                      multiple
                      collapse-tags
                      clearable
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="filter.responsibleIds"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="
                        selectAllFromSelect('filter.responsibleIds', listUsers)
                      "
                    >
                      <el-option
                        v-for="(user, key) in this.concatAll(
                          listUsers,
                          null,
                          $t('uti.mixinMasters.selectAll2')
                        )"
                        class="select-primary selected-all"
                        :key="key"
                        :label="user.name"
                        :value="user.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="12">
                  <el-form-item
                    :label="`${$t('grow.observeds')}`"
                    prop="observedIds"
                  >
                    <el-select
                      multiple
                      collapse-tags
                      clearable
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="filter.observedIds"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="
                        selectAllFromSelect('filter.observedIds', listObserveds)
                      "
                    >
                      <el-option
                        v-for="(user, key) in this.concatAll(
                          listObserveds,
                          null,
                          $t('uti.mixinMasters.selectAll2')
                        )"
                        class="select-primary selected-all"
                        :key="key"
                        :label="user.name"
                        :value="user.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="12">
                  <el-form-item
                    :label="`${$t('common_words.area2')}`"
                    prop="areaIds"
                  >
                    <el-select
                      multiple
                      collapse-tags
                      clearable
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="filter.areaIds"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="selectAllFromSelect('filter.areaIds', listAreas)"
                    >
                      <el-option
                        v-for="area in this.concatAll(
                          listAreas,
                          null,
                          $t('uti.mixinMasters.selectAll2')
                        )"
                        class="select-primary selected-all"
                        :value="area.id"
                        :label="area.name"
                        :key="area.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="12">
                  <el-form-item
                    :label="`${$t('common_words.farms')}`"
                    prop="farmIds"
                  >
                    <el-select
                      multiple
                      collapse-tags
                      clearable
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="filter.farmIds"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="selectAllFromSelect('filter.farmIds', listFarms)"
                    >
                      <el-option
                        v-for="(farm, key) in this.concatAll(
                          listFarms,
                          null,
                          $t('uti.mixinMasters.selectAll2')
                        )"
                        class="select-primary selected-all"
                        :key="key"
                        :label="farm.name"
                        :value="farm.id"
                      ></el-option>
                    </el-select>
                  </el-form-item> </el-col
              ></el-row>
              <el-form-item class="text-center">
                <el-button
                  class="btn btn-success custom-shadow-btn"
                  @click="consultData('filter')"
                  >{{ $t('common_words.filter') }}</el-button
                >
              </el-form-item>
            </el-form>
          </el-dialog>

          <el-dialog
            :title="`${$t('grow.opt')}`"
            :visible.sync="dialogVisibleFormOPT"
            width="70%"
          >
            <el-form :label-position="'top'" ref="formOPT">
              <div style="text-align: end">
                <el-button
                  class="btn btn-fg btn-add custom-shadow-btn"
                  :disabled="stepActive === 0"
                  @click="prevStep"
                >
                  <span class="el-icon-arrow-left"></span
                  >{{ $t('common_words.previous') }}
                </el-button>
                <el-button
                  class="btn btn-success custom-shadow-btn"
                  v-if="stepActive < totalSteps - 1"
                  @click="nextStep"
                >
                  {{ $t('common_words.next') }}
                  <span
                    class="el-icon-arrow-right"
                    style="align-items: center; display: flex"
                  ></span>
                </el-button>
                <el-button
                  class="btn btn-success custom-shadow-btn"
                  v-else
                  @click="finishProcess"
                >
                  {{ $t('common_words.save') }}
                </el-button>
              </div>
              <el-row :gutter="20">
                <el-col style="text-align: justify; padding: 0px 60px">
                  <div v-show="stepActive === 0" v-html="$t('grow.text')"></div>
                  <div v-show="stepActive === 1">
                    <h5>I. {{ $t('grow.stepOne') }}</h5>
                  </div>
                  <div v-show="stepActive === 2">
                    <h5>II. {{ $t('grow.stepTwo') }}</h5>
                  </div>
                  <div v-show="stepActive === 3">
                    <h5>III. {{ $t('grow.stepThree') }}</h5>
                  </div>
                  <div v-show="stepActive === 4">
                    <h5>IV. {{ $t('grow.stepFour') }}</h5>
                  </div>
                  <div v-show="stepActive === 5">
                    <h5>V. {{ $t('grow.stepFive') }}</h5>
                  </div>
                </el-col>
              </el-row>
            </el-form></el-dialog
          >
          <FullCalendar ref="fullCalendar" :options="calendarOptions"
        /></template>
      </card>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import i18n from 'src/i18n';
import { EventBus } from '../../../../../../util/bus';

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import allLocales from '@fullcalendar/core/locales-all';
import multiMonthPlugin from '@fullcalendar/multimonth';

export default {
  mixins: [MixinPermissions, mixinMasters, MixinMenu],
  components: {
    FullCalendar,
  },

  data() {
    return {
      model: {
        id: null,
        responsibleId: null,
        observedId: null,
        email: null,
        date: null,
        timeRange: [],
        week: null,
        year: null,
        farmId: null,
        areaId: null,
        statusId: null,
        status: null,
      },
      filter: {
        responsibleIds: [],
        observedIds: [],
        farmIds: [],
        areaIds: [],
      },
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },
      listUsers: [],
      listObserveds: [],
      listFarms: [],
      listAreas: [],
      listEvents: [],
      isDisabled: false,
      rules: {
        responsibleId: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        observedId: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$i18n.t('grow.validemailformat'),
            trigger: 'blur',
          },
        ],
        date: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        timeRange: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        farmId: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        areaId: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
      },
      rulesFilter: {
        responsibleIds: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        observedIds: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        farmIds: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        areaIds: [
          {
            required: true,
            message: this.$t('common_words.required_field'),
            trigger: 'change',
          },
        ],
      },
      stepActive: 0,
      totalSteps: 6,
      dialogVisible: false,
      dialogVisibleFilters: false,
      dialogVisibleFormOPT: false,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          multiMonthPlugin,
        ],
        /*validRange: function (nowDate) {
          return {
            start: nowDate,
          };
        },*/
        eventContent: function (arg) {
          return {
            html: arg.event.title,
          };
        },
        locales: allLocales,
        locale: 'es',
        headerToolbar: {
          left: 'prev,next today myFilterButton',
          center: 'title',
          right: 'multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay',
        },
        customButtons: {
          myFilterButton: {
            text: `${this.$t('common_words.filters')}`,
            click: () => {
              this.dialogVisibleFilters = true;
            },
          },
        },
        weekends: true,
        editable: false,
        displayEventTime: false,
        selectable: false,
        dayMaxEvents: false,
        eventDisplay: 'block',
        initialView: 'dayGridMonth',
        eventClick: this.handleEventClick,
        dateClick: this.handleDateClick,
        events: [],
      },
    };
  },

  methods: {
    nextStep() {
      this.stepActive++;
    },

    prevStep() {
      this.stepActive--;
    },

    finishProcess() {
      console.log('Process terminado');
    },

    /**
     * Close the form for creating an event
     */
    handleClose() {
      this.resetForm('form');
    },

    /**
     * Reset the variables in the event creation form
     *
     * @param {String} formName form name
     */
    resetForm(formName) {
      this.model.id = null;
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },

    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends;
    },

    /**
     * Add or update the event to the calendar
     *
     * @param {String} formName form name
     */
    handleEventAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.model.route = 'grow/optcapture';
          this.model.date = moment(this.model.date).format('YYYY-MM-DD');
          this.model.filters = this.filter;
          const now = moment();
          const eventDateTime = moment(
            `${this.model.date} ${this.model.timeRange[1]}`
          );
          if (now.isBefore(eventDateTime)) {
            this.model.statusId = 1;
          } else {
            this.model.statusId = 3;
          }
          if (this.model.id) {
            if (this.isUpdate()) {
              this.showHideLoading(true);
              Axios.updateMaster(this.model)
                .then((response) => {
                  this.dialogVisible = false;
                  this.listEvents = response.data.data;
                  this.calendarOptions.events = [];
                  this.listEvents.forEach((event) => {
                    this.addEvens(event);
                  });
                  this.showNotification(
                    response.data.message,
                    'success',
                    'nc-simple-add',
                    'Exitoso...'
                  );
                })
                .catch((error) => {
                  this.showMessageErrors(error);
                })
                .finally(() => {
                  this.showHideLoading();
                });
            } else {
              this.showMessageAccess();
            }
          } else {
            if (this.isCreate()) {
              this.showHideLoading(true);
              Axios.saveMaster(this.model)
                .then((response) => {
                  this.dialogVisible = false;
                  this.listEvents = response.data.data;
                  this.calendarOptions.events = [];
                  this.listEvents.forEach((event) => {
                    this.addEvens(event);
                  });
                  this.showNotification(
                    response.data.message,
                    'success',
                    'nc-simple-add',
                    'Exitoso...'
                  );
                })
                .catch((error) => {
                  this.showMessageErrors(error);
                })
                .finally(() => {
                  this.showHideLoading();
                });
            } else {
              this.showMessageAccess();
            }
          }
        } else {
          return false;
        }
      });
    },

    /**
     * Remove the event from the calendar
     *
     * @param {Number} id ID of the event to be deleted
     */
    handleEventRemove(id) {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'grow/optcapture/delete';
        this.model.filters = this.filter;
        Axios.postMasters(this.model)
          .then((response) => {
            this.dialogVisible = false;
            this.listEvents = response.data.data;
            this.calendarOptions.events = [];
            this.listEvents.forEach((event) => {
              this.addEvens(event);
            });
            this.showNotification(
              response.data.message,
              'success',
              'nc-simple-add',
              'Exitoso...'
            );
          })
          .catch((error) => this.showMessageErrors(error))
          .finally(() => {
            this.showHideLoading();
          });
      } else {
        this.showMessageAccess();
      }
    },

    /**
     * Displays the form for creating the event when we select a date from the calendar
     *
     * @param {Object} arg fullcalendar object
     */
    async handleDateClick(arg) {
      this.dialogVisible = true;
      this.isDisabled = false;
      const yearWeek = await this.getYearWeekMode(arg.dateStr);
      const year = yearWeek.slice(0, 4);
      const week = yearWeek.slice(4, 6);
      this.model = {
        id: null,
        responsibleId: null,
        observedId: null,
        email: null,
        date: arg.date,
        timeRange: ['00:00', '23:59'],
        year: year,
        week: week,
        farmId: null,
        areaId: null,
        statusId: 1,
        status: this.$i18n.t('common_words.scheduled'),
      };
    },

    /**
     * Displays the form for editing the event when we select an event from the calendar
     *
     * @param {Object} arg fullcalendar object
     */
    async handleEventClick(arg) {
      this.dialogVisible = true;
      const event = this.calendarOptions.events.find(
        (e) => e.id === arg.event.id * 1
      );
      const now = moment();
      const eventDateTime = moment(`${event.date} ${event.timeRange[1]}`);
      if (now.isBefore(eventDateTime)) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }

      if (event.statusId == 2) {
        this.isDisabled = true;
      }

      const yearWeek = await this.getYearWeekMode(event.date);
      const year = yearWeek.slice(0, 4);
      const week = yearWeek.slice(4, 6);
      this.model = {
        id: event.id,
        responsibleId: event.responsibleId,
        observedId: event.observedId,
        email: event.email,
        date: event.date,
        timeRange: event.timeRange,
        year: year,
        week: week,
        farmId: event.farmId,
        areaId: event.areaId,
        statusId: event.statusId,
        status: event.status,
      };
    },

    /**
     * Perform the query of events taking into account the filters of responsible parties, observers, purposes and areas
     *
     * @param {String} formName form name
     */
    consultData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.showHideLoading(true);
          let filter = {
            route: 'grow/optcapture/getlistevents',
            filters: this.filter,
          };
          Axios.postMasters(filter)
            .then((response) => {
              this.dialogVisibleFilters = false;
              this.listEvents = response.data.data;
              this.calendarOptions.events = [];
              this.listEvents.forEach((event) => {
                this.addEvens(event);
              });
            })
            .catch((error) => {
              this.showMessageErrors(error);
            })
            .finally(() => {
              this.showHideLoading();
            });
        } else {
          return false;
        }
      });
    },

    formOPT(name) {
      this.dialogVisibleFormOPT = true;
      this.stepActive = 0;
    },

    /**
     * Loads and renders events into the calendar view based on the provided filters.
     *
     * @param {Object} param - Event filter parameters.
     * @param {Number|null} param.id - Event ID.
     * @param {Number|null} param.responsibleId - Responsible user ID.
     * @param {Number|null} param.observedId - Observed user ID.
     * @param {String|null} param.email - User email.
     * @param {Number|null} param.farmId - Farm ID.
     * @param {Number|null} param.areaId - Area ID.
     * @param {Number|null} param.statusId - Status ID.
     * @param {String|null} param.date - Event date (YYYY-MM-DD).
     * @param {String|null} param.startTime - Event start time (HH:mm).
     * @param {String|null} param.endTime - Event end time (HH:mm).
     */
    addEvens(param) {
      const {
        id,
        responsibleId,
        observedId,
        email,
        farmId,
        areaId,
        statusId,
        date,
        startTime,
        endTime,
      } = param;

      const responsible = this.listUsers.find((r) => r.id === responsibleId);
      const observed = this.listObserveds.find((o) => o.id === observedId);
      const farm = this.listFarms.find((f) => f.id === farmId);
      const area = this.listAreas.find((a) => a.id === areaId);
      const title = `
            <strong>${startTime} - ${endTime}</strong>
            <strong>${this.$i18n.t('grow.responsible')}:</strong> ${
        responsible.first_name
      } ${responsible.last_name}<br>
            <strong>${this.$i18n.t('grow.observed')}:</strong> ${
        observed.first_name
      } ${observed.last_name}<br>
            <strong>${this.$i18n.t('common_words.farm')}:</strong> ${
        farm.name
      }<br>
            <strong>${this.$i18n.t('common_words.area')}:</strong> ${area.name}
          `;
      this.calendarOptions.events.push({
        id: id,
        responsibleId: responsibleId,
        observedId: observedId,
        email: email,
        farmId: farmId,
        areaId: areaId,
        statusId: statusId,
        status:
          statusId == 1
            ? this.$i18n.t('common_words.scheduled')
            : statusId == 2
            ? this.$i18n.t('common_words.completed')
            : this.$i18n.t('common_words.expired'),
        timeRange: [startTime, endTime],

        title: title,
        date: date,
        start: `${date}T${startTime}`,
        end: `${date}T${endTime}`,
        allDay: false,
        backgroundColor:
          statusId == 1 ? 'orange' : statusId == 2 ? 'green' : 'red',
        textColor: '#fff',
        display: 'block',
      });
    },

    /**
     * Assigns the corresponding ISO week number based on the selected date.
     *
     */
    async handleChangeDate() {
      let date = moment(this.model.date).format('YYYY-MM-DD');
      const yearWeek = await this.getYearWeekMode(date);
      const year = yearWeek.slice(0, 4);
      const week = yearWeek.slice(4, 6);
      this.model.year = year;
      this.model.week = week;
    },
    /**
     * Returns the year and ISO week number for a given date.
     *
     * @param {String} dateInput - Date string in YYYY-MM-DD format.
     * @returns {Object} Object containing year and week number.
     */
    async getYearWeekMode(dateInput) {
      try {
        this.showHideLoading(true);
        const response = await Axios.getMasters(
          `grow/optcapture/getyearweek/${dateInput}/6`
        );
        return String(response.data.data);
      } catch (error) {
        const message =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : 'Error';

        SweetAlert.warning(message);
        return null;
      } finally {
        this.showHideLoading(false);
      }
    },
  },

  created() {
    this.showHideLoading(true);
    let now = moment();
    let data = {
      route: 'grow/optcapture/getselectinfo',
      dateTime: now.format('YYYY-MM-DD HH:mm'),
      filters: this.filter,
    };
    Axios.postMasters(data)
      .then((response) => {
        this.listUsers = response.data.data.listUsers;
        this.listObserveds = response.data.data.listObserveds;
        this.listFarms = response.data.data.listFarms;
        this.listAreas = response.data.data.listAreas;
        this.listEvents = response.data.data.listEvents;
        this.calendarOptions.events = [];
        this.listEvents.forEach((event) => {
          this.addEvens(event);
        });
        this.filter.responsibleIds = this.listUsers.map((item) => item.id);
        this.filter.observedIds = this.listObserveds.map((item) => item.id);
        this.filter.farmIds = this.listFarms.map((item) => item.id);
        this.filter.areaIds = this.listAreas.map((item) => item.id);
      })
      .catch((error) => {
        this.showMessageErrors(error);
      })
      .finally(() => {
        this.showHideLoading();
      });
  },

  mounted() {
    this.selectedItemOnMenu('optcapture');
    EventBus.$on('locale-changed', (newLocale) => {
      this.calendarOptions.locale = newLocale == 'pt_BR' ? 'pt-br' : newLocale;
      this.calendarOptions.customButtons.myFilterButton.text = this.$t(
        'common_words.options'
      );
      this.calendarOptions.events = [];
      this.listEvents.forEach((event) => {
        this.addEvens(event);
      });
    });
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('optcapture');
  },
};
</script>
<style>
.fc-event {
  white-space: normal !important;
  height: auto !important;
  cursor: pointer;
}
.fc-event:hover {
  filter: brightness(1.1);
}
.fc-event-title,
.fc-event-title-container {
  white-space: normal !important;
  word-break: break-word;
}
.fc-event {
  border-radius: 6px;
  font-size: 12px;
}
.fc-event-main {
  padding: 4px 6px;
  line-height: 1.3;
}
</style>